import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "product/compound"

class service {

    selectList(params) {
        return http.list(path + "/selectList", params);
    }

    getForceReadById(id) {
        return http.getById(path, id, true).then(response => response.data);
    }

    getAll() {
        return http.list(path + "/getAll");
    }

    getCompoundsByMaterialId(materialId) {

        if (materialId > 0) {

            let params = new URLSearchParams()
            params.set("status", "1")
            params.set("materialId", materialId)

            return this.selectList(params)

        }

    }

}

export default new service();

